var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"25%"}},[_c('h1',[_vm._v("欢迎使用中国时尚知识产权保护中心管理后台")])])
}]

export { render, staticRenderFns }